import {range} from "@pg-mono/nodash";
import {userComUpdateUserAttributes, userComUserengage} from "@pg-mono/user-com";

import {IOfferNotificationChatBotFormValues, PhoneType} from "../constants/offer_notification_chatbot_form";
import {offerListNotificationEventName, OfferNotificationAttribute, offerNotificationEventName} from "../constants/offer_notification_user_com";
import {OfferNotificationVariant} from "../types/OfferNotificationVariant";

type SubscribeToNotificationType = IOfferNotificationChatBotFormValues & IOfferNotificationPriceData;
type IOfferNotificationPriceData = {
    price?: string;
    price_lower_limit?: number;
    price_upper_limit?: number;
};

const getRoomList = (rooms?: IOfferNotificationChatBotFormValues["rooms"]) => {
    if (!rooms || (!rooms.lower && !rooms.upper)) {
        return [];
    }

    const roomLower = rooms.lower || 1;
    const roomUpper = rooms.upper || 5;

    return range(roomLower, roomUpper + 1);
};

export const subscribeToOfferNotification = (formAndPriceData: SubscribeToNotificationType, variant: OfferNotificationVariant, userUuid?: string) => {
    const {price, price_lower_limit, price_upper_limit, ...formData} = formAndPriceData;
    const regionStats = formData.search.regions[0].stats;
    const voivodeship = regionStats.region_type_voivodeship?.name;
    const city = regionStats.region_type_city?.name;
    const district = regionStats.region_type_district?.name;
    const eventName = variant === OfferNotificationVariant.OFFER ? offerNotificationEventName : offerListNotificationEventName;
    const userComUpdatePayload = {
        event_name: eventName,
        ...(userUuid ? {[OfferNotificationAttribute.USER_ID]: userUuid} : {}),
        [OfferNotificationAttribute.PHONE_NUMBER]: `${formData.phone.code} ${formData.phone.number}`
    };

    const userComOfferNotificationEventPayload = {
        ...userComUpdatePayload,
        [OfferNotificationAttribute.VOIVODESHIP]: voivodeship,
        ...(city ? {[OfferNotificationAttribute.CITY]: city} : {}),
        ...(district ? {[OfferNotificationAttribute.DISTRICT]: district} : {}),
        [OfferNotificationAttribute.ROOMS]: getRoomList(formData.rooms).join(","),
        ...(formData.phone_type === PhoneType.Sms ? {[OfferNotificationAttribute.PHONE_MARKETING_CONSENT]: "tak"} : {}),
        ...(formData.phone_type === PhoneType.Whatsapp ? {[OfferNotificationAttribute.WHATSAPP_MARKETING_CONSENT]: "tak"} : {}),
        ...(formData.general_marketing_consent && variant === OfferNotificationVariant.LIST
            ? {[OfferNotificationAttribute.EMAIL_MARKETING_CONSENT]: "tak", [OfferNotificationAttribute.PHONE_MARKETING_CONSENT]: "tak"}
            : {[OfferNotificationAttribute.EMAIL_MARKETING_CONSENT]: "nie", [OfferNotificationAttribute.PHONE_MARKETING_CONSENT]: "nie"}),
        ...(price ? {[OfferNotificationAttribute.PRICE]: price} : {}),
        ...(price_lower_limit ? {[OfferNotificationAttribute.PRICE_LOWER_LIMIT]: price_lower_limit} : {}),
        ...(price_upper_limit ? {[OfferNotificationAttribute.PRICE_UPPER_LIMIT]: price_upper_limit} : {})
    };

    userComUserengage(eventName, userComOfferNotificationEventPayload);
    userComUpdateUserAttributes(userComUpdatePayload);
};
import {range} from "@pg-mono/nodash";
import {userComUpdateUserAttributes, userComUserengage} from "@pg-mono/user-com";

import {IOfferNotificationChatBotFormValues, PhoneType} from "../constants/offer_notification_chatbot_form";
import {offerListNotificationEventName, OfferNotificationAttribute, offerNotificationEventName} from "../constants/offer_notification_user_com";
import {OfferNotificationVariant} from "../types/OfferNotificationVariant";

type SubscribeToNotificationType = IOfferNotificationChatBotFormValues & IOfferNotificationPriceData;
type IOfferNotificationPriceData = {
    price?: string;
    price_lower_limit?: number;
    price_upper_limit?: number;
};

const getRoomList = (rooms?: IOfferNotificationChatBotFormValues["rooms"]) => {
    if (!rooms || (!rooms.lower && !rooms.upper)) {
        return [];
    }

    const roomLower = rooms.lower || 1;
    const roomUpper = rooms.upper || 5;

    return range(roomLower, roomUpper + 1);
};

export const subscribeToOfferNotification = (formAndPriceData: SubscribeToNotificationType, variant: OfferNotificationVariant, userUuid?: string) => {
    const {price, price_lower_limit, price_upper_limit, ...formData} = formAndPriceData;
    const regionStats = formData.search.regions[0].stats;
    const voivodeship = regionStats.region_type_voivodeship?.name;
    const city = regionStats.region_type_city?.name;
    const district = regionStats.region_type_district?.name;
    const eventName = variant === OfferNotificationVariant.OFFER ? offerNotificationEventName : offerListNotificationEventName;
    const userComUpdatePayload = {
        event_name: eventName,
        ...(userUuid ? {[OfferNotificationAttribute.USER_ID]: userUuid} : {}),
        [OfferNotificationAttribute.PHONE_NUMBER]: `${formData.phone.code} ${formData.phone.number}`
    };

    const userComOfferNotificationEventPayload = {
        ...userComUpdatePayload,
        [OfferNotificationAttribute.VOIVODESHIP]: voivodeship,
        ...(city ? {[OfferNotificationAttribute.CITY]: city} : {}),
        ...(district ? {[OfferNotificationAttribute.DISTRICT]: district} : {}),
        [OfferNotificationAttribute.ROOMS]: getRoomList(formData.rooms).join(","),
        ...(formData.phone_type === PhoneType.Sms ? {[OfferNotificationAttribute.PHONE_MARKETING_CONSENT]: "tak"} : {}),
        ...(formData.phone_type === PhoneType.Whatsapp ? {[OfferNotificationAttribute.WHATSAPP_MARKETING_CONSENT]: "tak"} : {}),
        ...(formData.general_marketing_consent && variant === OfferNotificationVariant.LIST
            ? {[OfferNotificationAttribute.EMAIL_MARKETING_CONSENT]: "tak", [OfferNotificationAttribute.PHONE_MARKETING_CONSENT]: "tak"}
            : {[OfferNotificationAttribute.EMAIL_MARKETING_CONSENT]: "nie", [OfferNotificationAttribute.PHONE_MARKETING_CONSENT]: "nie"}),
        ...(price ? {[OfferNotificationAttribute.PRICE]: price} : {}),
        ...(price_lower_limit ? {[OfferNotificationAttribute.PRICE_LOWER_LIMIT]: price_lower_limit} : {}),
        ...(price_upper_limit ? {[OfferNotificationAttribute.PRICE_UPPER_LIMIT]: price_upper_limit} : {})
    };

    userComUserengage(eventName, userComOfferNotificationEventPayload);
    userComUpdateUserAttributes(userComUpdatePayload);
};
